// IgnoreDangerHtml.js
import React from 'react';

const IgnoreDangerHtml = ({ text }) => {
  // Check if the text length exceeds 25 characters
//   const truncatedText = text.length > 25 ? text.substring(0, 25) + '...' : text;

  return <span  dangerouslySetInnerHTML={{ __html: text }} />;
};

export default IgnoreDangerHtml;

